import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  certifyingOfficialTrainingInfo,
  capitalizeFirstLetter,
} from '../helpers';

import { addStyleToShadowDomOnPages } from '../../utils/helpers';

const PrimaryOfficialTrainingInfo = () => {
  const formState = useSelector(state => state?.form?.data || {});

  const firstName = formState?.primaryOfficialDetails.fullName.first;
  const lastName = formState?.primaryOfficialDetails.fullName.last;

  useEffect(() => {
    // Insert CSS to hide 'For example: January 19 2000' hint on memorable dates
    // (can't be overridden by passing 'hint' to uiOptions):
    addStyleToShadowDomOnPages(
      [''],
      ['va-memorable-date'],
      '#dateHint {display: none}',
    );
  });

  return (
    <>
      <h3 className="vads-u-color--gray-dark vads-u-margin-top--0">
        {firstName && lastName
          ? `${capitalizeFirstLetter(firstName)} ${capitalizeFirstLetter(
              lastName,
            )}'s Section 305 training`
          : 'Section 305 Training'}
      </h3>
      {certifyingOfficialTrainingInfo}
    </>
  );
};

export default PrimaryOfficialTrainingInfo;
